import helper from 'store/helper';
import types from './types';

const fetchReport = () => helper.createAction(types.FETCH_REPORT);
const fetchReportSucceeded = (data) =>
  helper.createAction(types.FETCH_REPORT_SUCCEEDED, data);
const requestStart = () => helper.createAction(types.REQUEST_START);
const requestFailed = (error) =>
  helper.createAction(types.REQUEST_FAILED, { error });

const setMode = (mode) => helper.createAction(types.SET_MODE, { mode });
const setRowDimensions = (dimensions) =>
  helper.createAction(types.SET_ROW_DIMENSIONS, { dimensions });
const setColumnDimensions = (dimensions) =>
  helper.createAction(types.SET_COLUMN_DIMENSIONS, { dimensions });
const setMetrics = (metrics) =>
  helper.createAction(types.SET_METRICS, { metrics });
const setAxis = (axis) => helper.createAction(types.SET_AXIS, { axis });
const setProductAxis = (productAxis) =>
  helper.createAction(types.SET_PRODUCT_AXIS, { productAxis });
const setFilters = (filters) =>
  helper.createAction(types.SET_FILTERS, { filters });
const setTouchPointTargets = (targets) =>
  helper.createAction(types.SET_TOUCH_POINT_TARGETS, { targets });

const updatePage = (page) => helper.createAction(types.UPDATE_PAGE, { page });
const updateSort = (field, direction) =>
  helper.createAction(types.UPDATE_SORT, { field, direction });

const setCvDisplayColumns = (section, columns) =>
  helper.createAction(types.SET_CV_DISPLAY_COLUMNS, { section, columns });

const resetSettings = () => helper.createAction(types.RESET_SETTINGS);

const hydrateSettings = (payload) =>
  helper.createAction(types.HYDRATE_SETTINGS, payload);

const downloadCsv = () => helper.createAction(types.DOWNLOAD_CSV);

export default {
  fetchReport,
  fetchReportSucceeded,
  requestStart,
  requestFailed,

  setMode,
  setRowDimensions,
  setColumnDimensions,
  setMetrics,
  setAxis,
  setProductAxis,
  setFilters,
  setTouchPointTargets,

  updatePage,
  updateSort,

  setCvDisplayColumns,
  resetSettings,
  hydrateSettings,
  downloadCsv,
};
